"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialNetworkFieldLogic = void 0;
var social_network_fieldtype_1 = require("./social-network.fieldtype");
Object.defineProperty(exports, "SocialNetworkFieldLogic", { enumerable: true, get: function () { return social_network_fieldtype_1.SocialNetworkFieldLogic; } });
